
<!-- Displays a Certification on the candidate's dashboard -->
<mat-card-header class="justify-content-between">
  <mat-card-title class="mx-0">
    <!-- Certification Title  -->
    <a [routerLink]="['/profile']" [queryParams]="{ certificationId: certification.id }">
      <mat-icon>class</mat-icon><span>{{ certification.title }}</span>
    </a>
  </mat-card-title>
  <!-- Link to finish registration displayed if not yet purchased -->
  <!-- Candidates can no longer purchase certifications online, so no need to show this button  - User Story: 17616 -->
  <!-- <div *ngIf="certification.status === CertificationStatus.Inactive">
    <a
      [routerLink]="['../register/certification']"
      [queryParams]="{ certificationId: certification.certificationId, progress: certification.registrationProgress }"
      >{{ 'Dashboard.InactiveCertification.ContinueRegistration' | translate }}</a
    >
  </div> -->
</mat-card-header>
<mat-card-content>
  <!-- Test Details  -->
  <app-user-certification-test-item
    *ngFor="let test of certification.tests"
    [canAccess]="certification.status !== CertificationStatus.Inactive"
    [certificationPurchased]="certification.status !== CertificationStatus.Inactive"
    [test]="test"
  >
  </app-user-certification-test-item>
  <div *ngIf="isCompleted" class="mt-5" style="width: 50%">
    <app-completed-certification-details [certification]="certification" showCompletedCertificatonOptions="true"></app-completed-certification-details>
  </div>
</mat-card-content>
<hr class="mt-4 mb-4" *ngIf="!isLast" />
